export default __webpack_public_path__ + "static/media/mercadobitcoin-favicon.3ea5b7c8.png";